<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col class="common-card-col" cols="12">
        <AlertsTemplate
          :page_content="page_content"
          :isPowerdata="isPowerdata"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AlertsTemplate from "../components/AlertsTemplate";
import { content } from "../../config/powerdata_alerts.js";

export default {
  name: "PowerdataAlerts",
  components: { AlertsTemplate },
  data: function () {
    return {
      page_content: null,
      isPowerdata: true,
    };
  },
  created() {
    this.page_content = content;
  },
};
</script>
